import { SHORTCUT_TEXT_MATERIAL_CATEGORY_FIELDS } from '@@partner:graphql/query/textMaterial/textMaterialShortcut'
import { TextMaterialCategory, UpdateTextMaterialCategoryInput } from '@@partner:types:app'
import { gql, useMutation } from '@apollo/client'

export interface UpdateTextMaterialCategory {
  updateTextMaterialCategory: TextMaterialCategory
}

export interface UpdateTextMaterialCategoryVariables {
  textMaterialCategoryInfo: UpdateTextMaterialCategoryInput;
  upsert: boolean;
}

export const GQL_MUTATION_UPDATE_TEXT_MATERIAL_CATEGORY = gql`
  mutation($textMaterialCategoryInfo: TextMaterialCategoryInput!, $upsert: Boolean!) {
    updateTextMaterialCategory(textMaterialCategoryInfo: $textMaterialCategoryInfo, upsert: $upsert) {
      ${SHORTCUT_TEXT_MATERIAL_CATEGORY_FIELDS}
    }
  }
`

export const useMutateUpdateTextMaterialCategory = () =>
  useMutation<UpdateTextMaterialCategory, UpdateTextMaterialCategoryVariables>(
    GQL_MUTATION_UPDATE_TEXT_MATERIAL_CATEGORY
  )